import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import showToast from "./Toast/ToastNotification";
import { performLogout } from "./logoutHelper";

// session logout
export default function AutoLogout() {
    const navigate = useNavigate();
    const token = useSelector((state) => state.auth?.user?.data?.body?.data?.token);

    useEffect(() => {
        if (!token) return;

        try {
            const decoded = jwtDecode(token);
            const expiry = decoded.exp * 1000; // milliseconds
            const now = Date.now();
            const timeout = expiry - now;

            if (timeout <= 0) {
                showToast("error", "Token Expired!")
                performLogout(navigate);
            } else {
                const timer = setTimeout(() => {
                    showToast("error", "Token Expired!")
                    performLogout(navigate);
                }, timeout);

                return () => clearTimeout(timer);
            }
        } catch (err) {
            showToast("error", "Token Expired!")
            performLogout(navigate);
        }
    }, [token, navigate]);

    return null;
}
